<template>

  <div>

    <ckeditor v-model="templateText" :config="ck.config" @input="$emit('update:template', templateText)"></ckeditor>

  </div>

</template>

<script>

import Vue from 'vue';
import CKEditor from 'ckeditor4-vue';

Vue.use(CKEditor);

export default {

  props: {
    template: {type: String, required: true}
  },

  data() {
    return {
      templateText: '', // updated with prop watcher
        ck: {
          config: {
            contentsCss: [
              `${process.env.API_URL}/css/ckeditor/contents.css`, // copy of original CKEditor css
              `${process.env.API_URL}/css/ckeditor/contents-overrides.css` // our custom modifications
            ],
            extraPlugins: 'justify',
            toolbarGroups: [
              { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
              { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
              { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
              { name: 'insert', groups: [ 'insert' ] },
              { name: 'links', groups: [ 'links' ] },
              { name: 'forms', groups: [ 'forms' ] },
              { name: 'tools', groups: [ 'tools' ] },
              { name: 'others', groups: [ 'others' ] },
              { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
              { name: 'styles', groups: [ 'styles' ] },
              { name: 'colors', groups: [ 'colors' ] },
              { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
              { name: 'about', groups: [ 'about' ] }
            ],
            removeButtons: 'Subscript,Superscript,Cut,Copy,Paste,PasteText,PasteFromWord,Scayt,Anchor,SpecialChar,Maximize,RemoveFormat,About,Styles,Strike'
        }
      }
    };
  },

  watch: {
    template: function(newText, oldText) {
      this.templateText = newText;
    }
  }
};

</script>


// WEBPACK FOOTER //
// src/components/Template/TemplateEditor.vue